import Autocomplete from "react-autocomplete"

const AutocompleteSearch = (props) => {
  return <Autocomplete {...props} />
}

export default AutocompleteSearch
